import { Component, Input, OnInit } from '@angular/core';


/**
 * Component to group pivotal and major icons
 */
@Component({
    selector: 'rms-pivotal-ki',
    templateUrl: './pivotal-ki.component.html',
    styleUrls: ['./pivotal-ki.component.scss'],
    standalone: false
})
export class PivotalKiComponent implements OnInit {
  @Input() keyInflection: boolean;

  constructor() { }

  ngOnInit() {
  }

}
